(() => {
    "use strict";

    function copyLink(button) {
        const url = button.dataset.copyUrl;
        if (!url || !navigator.clipboard) {
            return;
        }
        const original = button.getAttribute("aria-label") || "";
        navigator.clipboard.writeText(url).then(() => {
            button.classList.add("is-copied");
            if (button.dataset.copiedLabel) {
                button.setAttribute("aria-label", button.dataset.copiedLabel);
            }
            window.setTimeout(() => {
                button.classList.remove("is-copied");
                if (original) {
                    button.setAttribute("aria-label", original);
                }
            }, 1800);
        }).catch(() => {});
    }

    function restoreChecklist(root) {
        root.querySelectorAll("[data-blog-checklist]").forEach((list) => {
            const key = `motiveacao.blog.checklist.${list.getAttribute("data-blog-checklist")}`;
            let stored = [];
            try {
                stored = JSON.parse(localStorage.getItem(key) || "[]");
            } catch (error) {
                stored = [];
            }
            list.querySelectorAll("input[type='checkbox']").forEach((input) => {
                input.checked = stored.includes(Number(input.value));
            });
            if (list.dataset.bound === "true") {
                return;
            }
            list.dataset.bound = "true";
            list.addEventListener("change", () => {
                const values = Array.from(list.querySelectorAll("input[type='checkbox']:checked"))
                    .map((input) => Number(input.value));
                try {
                    localStorage.setItem(key, JSON.stringify(values));
                } catch (error) {}
            });
        });
    }

    function observeToc(root) {
        const tocLinks = Array.from(root.querySelectorAll("[data-blog-toc] a[href^='#']"));
        if (!tocLinks.length || !("IntersectionObserver" in window)) {
            return;
        }
        const byId = new Map();
        tocLinks.forEach((link) => {
            const id = decodeURIComponent(link.getAttribute("href") || "").replace("#", "");
            const target = id ? document.getElementById(id) : null;
            if (target) {
                byId.set(target, link);
            }
        });
        if (!byId.size) {
            return;
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const link = byId.get(entry.target);
                if (!link) {
                    return;
                }
                if (entry.isIntersecting) {
                    tocLinks.forEach((item) => {
                        item.classList.remove("is-active");
                        item.removeAttribute("aria-current");
                    });
                    link.classList.add("is-active");
                    link.setAttribute("aria-current", "location");
                }
            });
        }, {
            rootMargin: "-30% 0px -55% 0px",
            threshold: 0.1,
        });
        byId.forEach((_, section) => observer.observe(section));
    }

    function syncMobileToc(root) {
        root.querySelectorAll(".blog-article-toc.is-mobile").forEach((details) => {
            const summary = details.querySelector("summary");
            if (!summary) {
                return;
            }
            const sync = () => summary.setAttribute("aria-expanded", details.open ? "true" : "false");
            sync();
            if (details.dataset.bound === "true") {
                return;
            }
            details.dataset.bound = "true";
            details.addEventListener("toggle", sync);
        });
    }

    function boot() {
        const root = document.querySelector("[data-blog-article]");
        if (!root) {
            return;
        }
        root.querySelectorAll("[data-blog-copy]").forEach((button) => {
            if (button.dataset.bound === "true") {
                return;
            }
            button.dataset.bound = "true";
            button.addEventListener("click", () => copyLink(button));
        });
        restoreChecklist(root);
        observeToc(root);
        syncMobileToc(root);
    }

    window.siteReady(boot);
})();
